<div class="dropdown-header">DODAJ</div>

<input #inputElement (input)="onSearchChange($event.target.value)"
  (keydown.arrowdown)="onArrowDown($event)" (keydown.arrowup)="onArrowUp($event)" (keyup.enter)="onEnter()" (keyup.escape)="onClickOutside()">

<div class="add-node-dropdown-separator"></div>

@if (state$ | async; as state) {
  @if (state.searchResult) {
    <div>
      @for (item of state.searchResult; track item.id) {
        <div class="add-node-dropdown-item" [class.selected]="$index === state.highlighted" (click)="onItemClick(item)">{{ item.name }}</div>
      }
    </div>
  }

  <!-- creating is a row the planner sees and picks, not a side effect of Enter (0110) -->
  @if (showsCreateRow(state)) {
    @if (state.searchResult?.length) {
      <div class="add-node-dropdown-separator"></div>
    }

    <div class="add-node-dropdown-item add-node-dropdown-create" [class.selected]="state.highlighted === (state.searchResult?.length ?? 0)"
      (click)="onCreateClick()">+ Utwórz „{{ state.search!.trim() }}”</div>
  }
}
